import { LinearProgress } from '@mui/material';

import BasePreview from '@modules/_shared/components/report-editor/preview/BasePreview';

const MobilePreview = () => {
  return (
    <BasePreview
      renderLoadingIndicator={() => (
        <LinearProgress
          variant="indeterminate"
          color="primary"
          sx={{
            zIndex: 2,
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            opacity: 0.4,
            height: 6,
          }}
        />
      )}
    />
  );
};

export default MobilePreview;
